import { InfiniteScrollCustomEvent } from '@ionic/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { HeadlineModel } from './models';
import { HeadlinesStatusEnum } from './models/headlines-status-enums';

export type HeadlinesFilters = {
  statusFilter: HeadlinesStatusEnum;
  archived: boolean;
  teamId: string | null;
};
export type HeadlinesFilterField = keyof HeadlinesFilters;

export const HeadlinesActions = createActionGroup({
  source: 'Headlines',
  events: {
    Init: emptyProps(),
    'Init Success': props<{ teamId: string }>(),
    Refresh: emptyProps(),
    'Fetch Paged': props<{ scrollEvent?: InfiniteScrollCustomEvent }>(),
    'Fetch Paged Success': props<{ response: any; scrollEvent?: InfiniteScrollCustomEvent }>(), // Make respons not any
    'Fetch Paged Error': props<{ error: unknown }>(),
    'Increment Page': props<{ scrollEvent: InfiniteScrollCustomEvent }>(),

    'Set Selected Headline': props<{ id?: string }>(),
    'Set Selected Headline Success': props<{ headline: any }>(),
    'Set Selected Headline Error': props<{ error: unknown }>(),
    'Set Filter Bar Team': props<{ teamId: string }>(),

    /**
     * Commits filter changes and triggers a fresh fetch.
     * Such as the "apply filters" button
     * `setByUser` denotes that the user is changing the filters versus programmatically
     * `filters` if passed expects all the filters to be sent together
     */
    'Apply Filters': props<{ setByUser?: boolean; filters?: HeadlinesFilters }>(),
    /** Resets every filter (and `teamId`) back to its default and clears `filterSet`. Used by "clear all" in the filter modal. */
    'Clear Filters': emptyProps(),
    /**
     * Resets a single filter field back to its default value and triggers a fresh fetch, same as `Apply Filters`.
     * Useful when cases such as a user removes an individual filter chip.
     */
    'Remove Filters': props<{ field: HeadlinesFilterField }>(),
    'Toggle Sort Direction': emptyProps(),

    'Update Headline': props<{ id: string; headline: Partial<HeadlineModel>; initialHeadline: HeadlineModel }>(),
    'Patch Headline Success': props<{ headline: HeadlineModel }>(),
    'Patch Headline Error': props<{ error: unknown; headline: HeadlineModel }>(),

    'Universal Create Success': props<{ headline: HeadlineModel; dispatchSource: string; toastMessage: string }>(),
  },
});
